import stickyNavbar from './components/sticky-navbar';
import stuckNavbarMenuToggle from './components/stuck-navbar-menu-toggle';
import masonryGrid from './components/masonry-grid';
import passwordVisibilityToggle from './components/password-visibility-toggle';
import fileDropArea from './components/file-drop-area';
//import formValidation from './components/form-validation';
import offcanvas from './components/offcanvas';
import scrollTopButton from './components/scroll-top-button';
import tooltip from './components/tooltip';
import popover from './components/popover';
//import toast from './components/toast';
import disableDropdownAutohide from './components/disable-dropdown-autohide';
import carousel from './components/carousel';
import gallery from './components/gallery';
import productGallery from './components/product-gallery';
import imageZoom from './components/image-zoom';
//import countdown from './components/countdown';
//import charts from './components/charts';
import videoButton from './components/video-button';
//import subscriptionForm from './components/subscription-form';
import smoothScroll from './components/smooth-scroll';
//import rangeSlider from './components/range-slider';
//import filterList from './components/filter-list';
//import dataFilter from './components/data-filter';
import labelUpdate from './components/label-update';
import radioTab from './components/radio-tab';
//import creditCard from './components/credit-card';
import masterCheckbox from './components/master-checkbox';

// require('bootstrap');

window._ = require('lodash');

window.axios = require('axios');

//window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
window.axios.defaults.headers.common = {
    'X-Requested-With': 'XMLHttpRequest',
    'X-CSRF-TOKEN' : document.querySelector('meta[name="csrf-token"]').getAttribute('content')
};


(function () {
    'use strict'

    var contentsToRemove = document.querySelectorAll('.remove-content');
    contentsToRemove.forEach(function (item) {
        item.remove();
    });

    var formsSearch = document.querySelectorAll('.form-search');
    formsSearch.forEach(function (item) {
        var ciSearch = item.querySelector('.ci-search');
        ciSearch.addEventListener('click', function (event) {
            event.preventDefault();
            if(item.querySelector('.input-search').value.length > 1)
                item.submit();
        });
        ciSearch.style.cursor = "pointer";
    });


    // cookie banner
    var cookieBannerBtn = document.querySelector('#accept-cookies');
    if(cookieBannerBtn){
        cookieBannerBtn.addEventListener('click', function () {
            setCookie("adam_gdpr_consent_cookies",1,365);
            document.querySelector('.cookies-banners').remove();
        });
    }

    // cart modal
    var addCartModal = new bootstrap.Modal(document.getElementById('add-cart-modal'), {});
    var modalProductName = document.querySelector('#modal-product-name');
    var cartCount = document.querySelector('.cart-count');

    // cart btn
    var addToCartBtns = document.querySelectorAll('.add-product-cart');
    addToCartBtns.forEach(function (item, idx) {
        item.addEventListener('click', function () {
            item.disabled=true;
            var productsToAdd = document.querySelector('#product-nbr-'+item.dataset.productId);
            axios({
                method: 'post',
                url: '/fr/cart/add',
                data: {
                    productId: item.dataset.productId,
                    productNbr: productsToAdd.value,
                    data: []
                }
            }).then(function (response) {
                if(response.data.success) {
                    modalProductName.innerHTML = response.data.productName;
                    cartCount.innerHTML = response.data.cartCount;
                    addCartModal.show();

                    dataLayer.push({ecommerce: null});
                    dataLayer.push({
                        event: "add_to_cart",
                        ecommerce: {
                            currency: "EUR",
                            value: 1,
                            items: [{
                                item_id: JSON.parse(response.config.data).productId,
                                item_name: response.data.productName,
                                quantity: JSON.parse(response.config.data).productNbr,
                                price: 0
                            }]
                        }
                    });
                } else {
                    frmResSuccess.classList.add('d-none');
                    frmResError.classList.remove('d-none');
                }
                item.disabled=false;
            });
        });
    });

    var closeCartModal = document.querySelector('#closeCartModal');
    closeCartModal.addEventListener('click', function (e) {
        e.preventDefault;
        addCartModal.hide();
    });

    /**
    * execute scripts by route
    */
    switch (route) {
        case "cart.payments":
        // disable payment buttons when already clicked
        var paymentBtns = document.querySelectorAll('.payment-btn');
        paymentBtns.forEach((elem) => {
            elem.addEventListener('click', function(event){
                togglePaymentBtns(false);
            });
        });

        // accept rules
        var rules = document.querySelector('#accept-rules');
        rules.addEventListener('change', function(event){
            togglePaymentBtns(event.target.checked);
        });
        function togglePaymentBtns(mode){
            paymentBtns.forEach((item) => {
                if(mode===true){
                    item.disabled=false;
                    item.classList.remove('disabled');
                }else{
                    item.disabled=true;
                    item.classList.add('disabled');
                }
            });
        }

        break;

        case "cart.editBillingAddress":
        var onlyPro = document.querySelectorAll('.company-only');
        var onlyCustomer = document.querySelectorAll('.customer-only');
        var customerInputs = document.querySelectorAll('.customer-input');
        var proInputs = document.querySelectorAll('.pro-input');

        document.querySelectorAll("input[name='is_pro']").forEach((input) => {
            input.addEventListener('change', function(event){
                if(event.target.id=="client_type_pro"){
                    onlyCustomer.forEach((elem) => { elem.classList.add('d-none') });
                    onlyPro.forEach((elem) => { elem.classList.remove('d-none') });
                    customerInputs.forEach((elem) => { elem.value="" });
                }else{
                    onlyCustomer.forEach((elem) => { elem.classList.remove('d-none') });
                    onlyPro.forEach((elem) => { elem.classList.add('d-none') });
                    proInputs.forEach((elem) => { elem.value="" });
                }
            });
        });

        break;

        case "cart":
        case "cart.details":
        case "cart.detailsPost":
        var totalPrice = document.querySelector('#total-price');
        var shippingCostPrice = document.querySelector('#shipping-cost-price');
        var cartListContent = document.querySelector('#cat-list-content');

        document.querySelectorAll('.removeProductFromCart').forEach(function (item) {
            item.addEventListener("click", function (e) {
                e.preventDefault();
                var cssid = "#product-nbr-" + e.target.dataset.productId
                document.querySelector(cssid).value = 0;
                cartChange();
            });
        });

        // cart change
        function cartChange() {
            let inputsCart = document.querySelectorAll('.cart-product-item');
            let productToUpdate = [];

            inputsCart.forEach(function (item, idx) {
                productToUpdate.push({productId: item.dataset.id, nbr: item.value});
            });
            axios.post('/fr/cart', {products:productToUpdate}, {
                headers: {'Content-Type': 'application/json'}
            })
            .then(response => {
                totalPrice.innerHTML = response.data.totalPrice.toFixed(2);
                shippingCostPrice.innerHTML = response.data.shipping.costTaxDefault.toFixed(2)+'€';
                cartListContent.innerHTML = response.data.productsListHtml;
                cartCount.innerHTML = response.data.cartCount;
            })
            .catch(err => {
                location.reload();
            });
        }
        function shippingChange() {
            let country = document.querySelector('input[name=shipping-country]:checked');
            let shipping = {country:country.value};
            axios.post('/fr/cart', {shipping:shipping}, {
                headers: {'Content-Type': 'application/json'}
            })
            .then(response => {
                totalPrice.innerHTML = response.data.totalPrice.toFixed(2);
                shippingCostPrice.innerHTML = response.data.shipping.costTaxDefault.toFixed(2)+'€';
                if(response.data.shipping.countryId == 0)
                document.querySelector("#shippingSection").classList.add('d-none');
                else
                document.querySelector("#shippingSection").classList.remove('d-none');
            })
            .catch(err => {
                location.reload();
            });
        }
        window.cartChange = cartChange;

        // Shipping cost
        // detect country shipping change
        document.querySelectorAll("input[name='shipping-country']").forEach((input) => {
            input.addEventListener('change', function(event){
                shippingChange();
            });

        });
        break;

        case "promos":
        const frmEmail = document.querySelector('#frm-email');
        const frmPhone = document.querySelector('#frm-phone');
        const frmRules = document.querySelector('#frm-rules');
        const frmResSuccess = document.querySelector('#frm-result-success');
        const frmResError = document.querySelector('#frm-result-error');
        var btnNewsletter = document.querySelector('#newsletter-subscribe');
        var country = 'be';
        btnNewsletter.addEventListener('click', function () {
            axios({
                method: 'post',
                url: '/api/newsletter/subscribe',
                data: {
                    email: frmEmail.value,
                    phone: frmPhone.value,
                    lang: 'fr',
                    country: country,
                    rules: frmRules.checked
                }
            }).then(function (response) {

                if(response.data.success==true){
                    frmResSuccess.classList.remove('d-none');
                    frmResError.classList.add('d-none');
                    frmEmail.value = '';
                    frmPhone.value = '';
                    frmRules.checked=false;
                }else{
                    frmResSuccess.classList.add('d-none');
                    frmResError.classList.remove('d-none');
                }
            });
        });

        const countryPhone = document.querySelector("#frm-phone");
        var iti = intlTelInput(countryPhone, {
            onlyCountries: ["be"],
            /* onlyCountries: ["al", "ad", "at", "by", "be", "ba", "bg", "hr", "cz", "dk",
            "ee", "fo", "fi", "fr", "de", "gi", "gr", "va", "hu", "is", "ie", "it", "lv",
            "li", "lt", "lu", "mk", "mt", "md", "mc", "me", "nl", "no", "pl", "pt", "ro",
            "ru", "sm", "rs", "sk", "si", "es", "se", "ch", "ua", "gb"], */
            utilsScript: "https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/17.0.8/js/utils.js",
            //preferredCountries:['be','fr','lu']
            // any initialisation options go here
        });


        var countryData = window.intlTelInputGlobals.getCountryData();
        // listen to the telephone input for changes
        countryPhone.addEventListener('countrychange', function(e) {
            country = iti.getSelectedCountryData().iso2;
        });

        /* const info = document.querySelector(".alert-info");

        function process(event) {
            event.preventDefault();

            const phoneNumber = phoneInput.getNumber();

            info.style.display = "";
            info.innerHTML = `Phone number in E.164 format: <strong>${phoneNumber}</strong>`;
        } */

        break;

        case "contact":
        ///////////////// map
        //{{-- https://awesomeopensource.com/project/pointhi/leaflet-color-markers --}}
        var map = L.map('map', { scrollWheelZoom: false }).setView([50.67652, 5.08531], 10);

        L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
        /* attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors' */
    }).addTo(map);

    var greenIcon = new L.Icon({
        iconUrl: 'https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-2x-red.png',
        shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/0.7.7/images/marker-shadow.png',
        iconSize: [25, 41],
        iconAnchor: [12, 41],
        popupAnchor: [1, -34],
        shadowSize: [41, 41]
    });

    var arrayOfLatLngs = [];
    for (const [key, item] of Object.entries(address)) {
        let longLats = [item.latitude, item.longitude]
        arrayOfLatLngs[key] = longLats;
        L.marker(longLats, {icon: greenIcon}).addTo(map);
    }
    /*  var bounds = new L.LatLngBounds(arrayOfLatLngs);
    map.fitBounds(bounds); */

    ///////////////// Form
    const contactFrm = document.querySelector('.contact-frm');
    contactFrm.setAttribute('action', contactFrmUrl);
    contactFrm.addEventListener("submit", function(e){
        e.preventDefault();
        e.stopPropagation();
        contactFrm.classList.add('was-validated');
        if (contactFrm.checkValidity() === false) {
            console.log('bad !');
        } else {
            document.querySelector('#contact-form-btn-processing').classList.remove('d-none');
            document.querySelector('#contact-form-btn').classList.add('d-none');

            var email = document.querySelector('#cf-email').value;
            console.log(email);
            dataLayer.push({
                event: "ContactWebform",
                email: email
            });

            contactFrm.submit();
        }
    });
    break;

    case "admin.categories.edit":

    break;
}
function setCookie(name,value,days) {
    var expires = "";
    if (days) {
        var date = new Date();
        date.setTime(date.getTime() + (days*24*60*60*1000));
        expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "")  + expires + "; path=/";
}

})()
